import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/lakewood-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-lakewood-colorado",
      statusCode: 301,
    });
  },
});
